import { MaterialSymbols_700Bold } from '@expo-google-fonts/material-symbols/700Bold';

import type { AndroidSymbolWeight } from '../..';
const weight: AndroidSymbolWeight = {
  name: 'MaterialSymbols_700Bold',
  font: MaterialSymbols_700Bold,
};
export default weight;
